import React, { useContext, useEffect } from 'react';
import { Radio, RadioGroup } from '@mui/material';
import { modifierContext } from '../../ModifierProvider';
import { getModifierMinSelections, isAutoApplied } from '../../utils';
import OptionRow from '../OptionRow';

function SingleSelectModifier({ modifier, disabled }) {
  const { isSelected, handleChange } = useContext(modifierContext);
  useEffect(() => {
    if (!isAutoApplied(modifier) || modifier.options.some((option) => isSelected({ modifier, option }))) {
      return;
    }
    handleChange({ modifier, option: modifier.options[0], value: { ...modifier.options[0], qty: 1 } });
  }, [modifier, handleChange, isSelected]);

  return (
    <RadioGroup name={String(modifier.id)}>
      {modifier.options.map((option) => {
        const checked = isSelected({ option, modifier });
        return (
          <OptionRow key={option.id} option={option}>
            <Radio
              checked={checked}
              disabled={disabled}
              onClick={(e) => {
                if (checked && getModifierMinSelections(modifier) === 0) {
                  return handleChange({ modifier, option, value: undefined });
                }
                handleChange({
                  modifier,
                  option,
                  value: { ...option, qty: 1 },
                });
              }}
              data-testid={`item-modifier-radio-${option.id}`}
            />
          </OptionRow>
        );
      })}
    </RadioGroup>
  );
}

export default SingleSelectModifier;
